import React from 'react';
import { useI18n } from './i18n';
import { oilResult } from './productScoring';

function OilList({ sheets, onSelect }) {
  const { t, tc, formatDate, formatNumber } = useI18n();
  if (sheets.length === 0) return <div className="empty-state">{t('oil.list.empty')}</div>;

  return (
    <div className="sheets-list">
      <h2>{t('oil.list.title')}</h2>
      <div className="cards">
        {sheets.map((s) => {
          const result = oilResult(s);
          const category = s.category_eu || result.categoryEu;
          return (
            <div key={s.id} className="card" onClick={() => onSelect(s)}>
              <div className="card-header">
                <h3>{s.product_name}</h3>
                {s.harvest_year && <span className="vintage">{s.harvest_year}</span>}
              </div>
              <div className="card-body">
                {s.producer && <p>{s.producer}</p>}
                {s.origin && <p className="area">{s.origin}</p>}
                <div className="card-score-final">{tc('oil.category', category)}</div>
                <p className="area">
                  {t('oil.p.fruity')} {formatNumber(s.fruity, 1)} · {t('oil.p.bitter')} {formatNumber(s.bitter, 1)} · {t('oil.p.pungent')} {formatNumber(s.pungent, 1)}
                </p>
              </div>
              <div className="card-footer">
                {formatDate(s.tasting_date) || '—'} {s.taster ? `· ${s.taster}` : ''}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default OilList;
